/* eslint-disable */

import { isMobileWindow, isLandscapeWindow } from '@helpers/deviceWindow'
import Cookies from 'universal-cookie'
import { AB_TESTS } from '@constants/ab-test-flags'
import { getFromBrowserStorage } from '@helpers/storage'

const hasWindow = typeof window !== 'undefined'
const cookies = new Cookies()

const abTest = {}
const activeABTests = AB_TESTS?.filter(test => test.isActive) ?? []

if (activeABTests.length) {
  const storedAbTesting = getFromBrowserStorage('session', 'abTesting')
  const abTestingAssignments = {}

  // iterate over activeABTests to assign initial value (A or B) for each test
  // - check first to see if the test has a stored assignment in sessionStorage
  // - if so, use that value
  // - if not, assign a new random value
  activeABTests.forEach(test => {
    if (storedAbTesting && storedAbTesting[test.name]) {
      abTestingAssignments[test.name] = storedAbTesting[test.name]
    } else {
      abTestingAssignments[test.name] = Math.random() * 100 <= test.optionAPercent ? 'A' : 'B'
    }
  })

  abTest.abTesting = { ...abTestingAssignments }

  if (hasWindow) {
    try {
      sessionStorage.setItem('abTesting', JSON.stringify(abTestingAssignments))
      window.dataLayer = window.dataLayer || []
      activeABTests.forEach(test => {
        window.dataLayer.push({
          event: 'rtg_ab_test',
          rtg_experiment_name: test.name,
          rtg_experiment_group: abTestingAssignments[test.name],
        })
      })
    } catch (err) {
      console.error('Error setting up AB Test variables in redux/global >>> ', err)
    }
  }
}

// Actions
export const SET_IS_MOBILE = 'SET_IS_MOBILE'
export const SET_IS_LANDSCAPE = 'SET_IS_LANDSCAPE'
export const SET_HIDE_INFO_BANNER = 'SET_HIDE_INFO_BANNER'
export const SET_SHOW_SEARCH_RESULTS = 'SET_SHOW_SEARCH_RESULTS'
export const SET_PLP_GRID_WIDTH = 'SET_PLP_GRID_WIDTH'
export const SET_MOBILE_SHOW_MEGANAV = 'SET_MOBILE_SHOW_MEGANAV'
export const SET_HEADER_SIZE = 'SET_HEADER_SIZE'

// Action Creators
export function setIsMobile(isMobile) {
  return { type: SET_IS_MOBILE, isMobile }
}

export function setIsLandscape(isLandscape) {
  return { type: SET_IS_LANDSCAPE, isLandscape }
}

export function setHideInfoBanner(hideInfoBanner) {
  return { type: SET_HIDE_INFO_BANNER, hideInfoBanner }
}

export function setShowSearchResults(showSearchResults) {
  return { type: SET_SHOW_SEARCH_RESULTS, showSearchResults }
}

export function setMobileShowMeganav(showMeganav) {
  return { type: SET_MOBILE_SHOW_MEGANAV, showMeganav }
}

export function setHeaderSize(headerSize) {
  return { type: SET_HEADER_SIZE, headerSize }
}

// Reducer
const initialState = {
  hideInfoBanner: hasWindow ? !!cookies?.get('__SHOULD_NOT_OPEN_INFO_BANNER__') ?? false : false,
  isMobile: isMobileWindow(),
  isLandscape: isLandscapeWindow(),
  showSearchResults: false,
  showMeganavMobile: false,
  headerSize: 111,
  ...abTest,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.isMobile,
      }
    case SET_IS_LANDSCAPE:
      return {
        ...state,
        isLandscape: action.isLandscape,
      }
    case SET_HIDE_INFO_BANNER:
      return {
        ...state,
        hideInfoBanner: action.hideInfoBanner,
      }
    case SET_SHOW_SEARCH_RESULTS:
      return {
        ...state,
        showSearchResults: action.showSearchResults,
      }
    case SET_MOBILE_SHOW_MEGANAV:
      return {
        ...state,
        showMeganavMobile: action.showMeganav,
      }
    case SET_HEADER_SIZE:
      return {
        ...state,
        headerSize: action.headerSize,
      }
    default:
      return state
  }
}
